import React from "react";
import PropTypes from "prop-types";
import Button from "../elements/button";

var ListboxInfoBar = function ListboxInfoBar(_ref) {
  var count = _ref.count,
      showSelectedOnly = _ref.showSelectedOnly,
      onClear = _ref.onClear,
      onShowSelected = _ref.onShowSelected,
      disableShowSelected = _ref.disableShowSelected;
  return /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--infobar"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "et-listbox--infobar-count"
  }, count), /*#__PURE__*/React.createElement(Button, {
    disabled: !count,
    className: "et-listbox--infobar-link",
    type: "simple",
    onClick: function onClick() {
      onClear();
      onShowSelected(false);
    }
  }, "Clear")), /*#__PURE__*/React.createElement("div", {
    className: "et-listbox--show-selected"
  }, showSelectedOnly ? /*#__PURE__*/React.createElement(Button, {
    label: "Show all items",
    className: "et-listbox--infobar-link",
    type: "simple",
    onClick: function onClick() {
      return onShowSelected(false);
    }
  }, "View All") : /*#__PURE__*/React.createElement("span", {
    className: "et-listbox--infobar-text"
  }, "View All"), /*#__PURE__*/React.createElement("span", {
    className: "et-listbox--infobar-separator"
  }, "|"), showSelectedOnly ? /*#__PURE__*/React.createElement("span", {
    className: "et-listbox--infobar-text"
  }, "View Selected") : /*#__PURE__*/React.createElement(Button, {
    label: "Show selected items only",
    disabled: !count || disableShowSelected,
    className: "et-listbox--infobar-link",
    type: "simple",
    onClick: function onClick() {
      return onShowSelected(true);
    }
  }, "View Selected")));
};

ListboxInfoBar.propTypes = {
  count: PropTypes.number.isRequired,
  showSelectedOnly: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  onShowSelected: PropTypes.func.isRequired,
  disableShowSelected: PropTypes.bool.isRequired
};
export default ListboxInfoBar;